import http from '@/plugins/axios_plugin';
class ServiceCores {
    listar () {
        return http.get('/api/cores')
    }

    listarCoresProduto(produto_id) {
        return http.get(`/api/cores/${produto_id}`);
    }

    salvar (cor) {
        return http.post('/api/cores/salvar', cor)
    }

    atualizar (cor_id, cor) {
        return http.post('/api/cores/' + cor_id + '/atualizar', cor)
    }

    excluir (cor_id) {
        return http.post('/api/cores/' + cor_id + '/excluir');
    }
}

export default new ServiceCores();